
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

class CustomCheckout {
  constructor() {
    this.isProd = true
    this.optBtnQuery = ''
    this.config = {
      "maketPrefix": ['/en-'],
      "host": this.isProd ? 'https://www.aosom.com' : 'https://popdev.aosom.com',
      "cartFormIdAttr": this.isProd ? 'form' : 'id',
      "headFormId": this.isProd ? 'CartDrawer-Form' : 'cart-notification-form',
      "headCartId": this.isProd ? 'cart-drawer' : 'cart-notification-form',
      "otherBtnId": this.isProd ? 'other-checkouts' : 'dynamic-checkout-cart',
    }
    this.customerInfo = this.getCustomerInfo()
    this.init();
  }

  init() {
    if (window.location.pathname.includes('/cart')) {
      this.handleCartPageCheckout()
    } else {
      this.handleHeaderCheckout()
    }
  }
  isMarket() {
    let isMarket = false
    const path = window.location.pathname;
    if (this.config.maketPrefix.some(prefix => path.startsWith(prefix))) {
      isMarket = true
    }
    return isMarket
  }
  getSomeMaps() {
    const path = window.location.pathname;
    const match = path.match(/^\/([^\/]+)/);
    const firstDirectory = match ? match[1] : '';
    const maps = {
      'en-ca': {
        skuPrefix: 'CA-',
        market: 'en-ca'
      },
      'en-gb': {
        skuPrefix: 'UK-',
        market: 'en-gb'
      }
    }
    return {
      maps: maps,
      map: maps[firstDirectory] || null
    }
  }
  // 头部购物车弹窗 checkout 按钮处理
  handleHeaderCheckout() {
    // let checkoutBtn = document.querySelector(`#${this.config.headCartId} [name="checkout"]`)
    this.optBtnQuery = `#${this.config.headCartId} [name="checkout"]`
    // if (!checkoutBtn) return;
    // const formEl = document.getElementById(this.config.headFormId)
    // if (!formEl) return;
    // 新增委托绑定
    document.body.addEventListener('submit', (e) => {
      const target = e.target;
      if (target && target.id === this.config.headFormId && !this.ignorePreventDefault) {
        e.preventDefault()
        this.handleCheckout(1, target);
      }
    });
    // formEl.addEventListener("submit", e => {
    //   // 如果是市场，则拦截
    //   if (this.isMarket()) {
    //     e.preventDefault()
    //     console.log('------------------ checkout click event')
    //     this.handleCheckout(1)
    //   }
    // })
  }
  // 购物车页面 checkout 按钮处理
  handleCartPageCheckout() {
    let checkoutBtn = document.getElementById('checkout')
    this.optBtnQuery = '#checkout'
    if (this.isProd) {
      checkoutBtn = document.querySelector('form.cart-form [name="checkout"]')
      this.optBtnQuery = '[name="checkout"]'
    }
    if (!checkoutBtn) return;
    const isMarcket = this.isMarket()
    const formId = checkoutBtn.getAttribute('form')
    const formEl = document.getElementById(formId)
    if (!formEl) return;
    formEl.addEventListener("submit", e => {
      // 如果是市场，则拦截
      if (!this.ignorePreventDefault) {
        e.preventDefault();
        this.handleCheckout(2, checkoutBtn)
      }
    })
    // 其他按钮处理
    const otherCheckouts = document.getElementById(this.config.otherBtnId)
    if (otherCheckouts) {
      otherCheckouts.addEventListener("click", (e) => {
        // 如果是市场，则拦截
        if (!this.ignorePreventDefault) {
          e.preventDefault()
          console.log('------------------ checkout click event 1')
          this.handleCheckout(2, otherCheckouts)
        }
      })
    }
    if (!isMarcket) {
      otherCheckouts.style.display = "none"
    }
  }
  // 将Buffer转换为Base64
  arrayBufferToBase64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  }
  // 加签，返回拼接后的字符串
  paramSign(params, timestamp) {
    // 1. 去除空值并字典顺序排序
    const filteredParams = Object.keys(params)
      .filter(key => ['boolean', 'number', 'string'].includes(typeof params[key]))
      .sort((a, b) => a.localeCompare(b))
      .reduce((obj, key) => {
        obj[key] = params[key];
        return obj;
      }, {});

    // 2. 拼接时间戳和加密后的随机密钥
    const paramString = Object.entries(filteredParams).map(([key, value]) => `${key}^${value}`).join('*');
    return `${paramString}*timestamp^${timestamp}`;
  }
  // 加签，通过SHA算法获得签名
  async paramSign2(paramStr, isBase64) {
    // 3. 通过SHA算法获得签名
    const encoder = new TextEncoder();
    const data = encoder.encode(paramStr);
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
    if (isBase64) {
      return this.arrayBufferToBase64(hashBuffer);
    } else {
      return hashBuffer;
    }
  }

  async getProdData() {
    // 获取购物车数据
    const drawerEl = document.getElementById("CartDrawer");
    const cartEls = drawerEl.querySelectorAll('li.cart-item') || []
    let cartDatas = []
    cartEls.forEach(item => {
      cartDatas.push({
        "mainSku": item.getAttribute('sku'),
        "qty": item.querySelector('.js-counter-quantity').value
      })
    })
    return cartDatas
  }
  async getCartSync() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart; // 返回数据后继续执行后续代码
    } catch (error) {
      console.error('获取失败:', error);
      return null;
    }
  }
  async getTestData() {
    let cartDatas = []
    const cartData = await this.getCartSync()
    const someMaps = this.getSomeMaps()
    let checkoutMarket = ''
    const currentMap = someMaps.map
    const allKeys = Object.keys(someMaps.maps)
    // 如何 currentMap 存在 对allKeys进行重新排序，优先把currentMap.market 放在第一位
    if (currentMap) {
      const idx = allKeys.indexOf(currentMap.market)
      if (idx > -1) {
        allKeys.splice(idx, 1)
        allKeys.unshift(currentMap.market)
      }
    }

    for (let i = 0; i < allKeys.length; i++) {
      const key = allKeys[i]
      const skuPrefix = someMaps.maps[key].skuPrefix
      cartData.items.forEach(item => {
        if (item.sku.startsWith(skuPrefix)) {
          cartDatas.push({
            "mainSku": item.sku,
            "qty": item.quantity
          })
          checkoutMarket = someMaps.maps[key].market
        }
      })
      if (cartDatas.length > 0) {
        break
      }
    }

    

    console.log('-------------------- ', cartData); // 输出购物车数据
    return {
      cartDatas,
      checkoutMarket
    }
  }
  // 获取cookie
  getCookie(name) {
    try {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) {
        const cookieValue = parts.pop().split(';').shift();
        return cookieValue ? decodeURIComponent(cookieValue) : null;
      }
      return null;
    } catch (error) {
      console.error('Error getting cookie:', error);
      return null;
    }
  }
  // 主店铺的登出逻辑
  subStoreLogout() {
    // 向所有子店铺发送登出指令
    const childDomains = ['https://outsunnystore.myshopify.com'];
    childDomains.forEach(domain => {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = `${domain}/account/logout`;
      document.body.appendChild(iframe);
    });
  }
  // 清空购物车
  clearCart() {
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        console.log('购物车已清空:', data);
        window.location.reload()
      })
      .catch(error => {
        console.error('清空购物车出错:', error);
      });
  }
  // 获取支付状态接口
  async getPayStatus(cartToken) {
    // 从cookie 获取购物车 token
    if (!cartToken) {
      return
    }
    fetch(`${this.config.host}/rest/v1/spf/lp/${cartToken}`)
      .then((response) => {
        return response.json();
      }).then(res => {
        if (res?.code === 0) {
          if (res?.data === 1) {
            // 支付成功，清空购物车
            this.clearCart()
          } else if (res?.data === 0) {
            // 继续轮询
            setTimeout(() => {
              this.getPayStatus(cartToken)
            }, 2000)
          } else if (res?.data === -1) {
            // 支付失败
            console.log('------------------ 支付失败')
          }
        }
      })
  }
  // 获取用户邮箱
  getCustomerInfo() {
    const uInfo = {}
    try {
      // 方法3：从页面元素获取
      const emailElement = document.querySelector('div[data-email]');
      if (emailElement) {
        uInfo.email = emailElement.getAttribute('data-email')
        uInfo.firstName = emailElement.getAttribute('first-name')
        uInfo.lastName = emailElement.getAttribute('last-name')
        emailElement.remove()
      }
      
      return uInfo;
    } catch (error) {
      console.error('Error getting customer email:', error);
      return uInfo;
    }
  }
  // 处理购物车弹窗 checkout 按钮点击操作
  async handleCheckout(type, target) {
    if (this.paying) {
      return
    }
    let { cartDatas, checkoutMarket } = await this.getTestData(type)
    if (checkoutMarket) {
      this.ignorePreventDefault = false
      const timestamp = new Date().getTime();
      // 可能需要加一个配置字典，来准确区分市场
      // const path = window.location.pathname;
      // const match = path.match(/^\/([^\/]+)/);
      // const firstDirectory = match ? match[1] : '';



      // !!! --------- 上线需要修改为动态获取的 market, store 字段
      const params = {
        items: cartDatas,
        "market": checkoutMarket,
        "host": window.location.host,
        ...this.customerInfo
      }
      const cartToken = this.getCookie('cart')
      const cartSign = this.getCookie('cart_sig')
      if (cartToken) {
        params.cartToken = cartToken
      }
      if (cartSign) {
        params.cartSig = cartSign
      }
      console.log('------------------ params', params)
      const signStr = this.paramSign(params, timestamp);
      const signature = await this.paramSign2(signStr, true);
      const headers = {
        "X-Timestamp": timestamp,
        "X-Signature": signature,
      }
      const otherConfigs = { ...fetchConfig() }
      if (otherConfigs.headers) {
        otherConfigs.headers = {
          ...otherConfigs.headers,
          ...headers
        }
      } else {
        otherConfigs.headers = headers
      }
      const body = JSON.stringify(params);
      this.paying = true
      const optBtnQueryEl = this.optBtnQuery && document.querySelector(this.optBtnQuery)
      if (optBtnQueryEl) {
        optBtnQueryEl.setAttribute('disabled', true)
      }
      // 按钮置灰
      fetch(`${this.config.host}/rest/v1/spf/checkout`, { ...otherConfigs, ...{ body } })
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          console.log('------------- res', res)
          if (res && res.code === 0 && res.data) {
            optBtnQueryEl && optBtnQueryEl.removeAttribute('disabled')
            // https://outsunnystore.myshopify.com/cart/c/Z2NwLXVzLWVhc3QxOjAxSlBQVjFQTjhWRjg5WTBHNURRODNGM0FU?key=6a33f9a4fb7fdadfd60d5cc5bb903b5e，截取最后一级url
            // const urlObj = new URL(res.data)
            // const cartToken = urlObj.pathname.split('/').pop()
            // // 创建一个a标签，并在新标签页打开 res.data
            // const aEl = document.createElement("a");
            // aEl.href = res.data;
            // aEl.target = "_blank";
            // aEl.click();
            window.location.href = res.data
            // window.location.href = res.data
          } else {
            res.msg && window.alert(res.msg)
            this.paying = false
            optBtnQueryEl && optBtnQueryEl.removeAttribute('disabled')
          }
        }).catch(() => {
          this.paying = false
          optBtnQueryEl && optBtnQueryEl.removeAttribute('disabled')
        })
    } else {
      this.ignorePreventDefault = true
      target.click()
    }
  }
}
new CustomCheckout()